<template>
  <div class="gestionASTT-container col-sm-12">
    <div
      v-if="erreurGlobale != null"
      class="alert alert-danger text-left global-errors mb-5"
    >
      <p>
        {{ erreurGlobale }}
      </p>
    </div>

    <p class="gestionASTT-page-title">
      {{ "preinscription_ast_title" | translate("fr") }}
    </p>

    <div class="gestionASTT pb-5">
      <!-- Je suis -->
      <div class="jeSuisPart pt-5">
        <p class="gestionASTTTitle">JE SUIS</p>
        <div class="row d-flex justify-content-left mb-4">
          <div class="title_line" style="width: 75px"></div>
        </div>

        <div class="row">
          <p class="gestionASTTText">
            {{ "preinscription_prenom" | translate(locale) }} :
          </p>
          <p class="gestionASTTTextBold">{{ preinscription.data.prenom }}</p>
        </div>
        <div class="row">
          <p class="gestionASTTText">
            {{ "preinscription_nom" | translate(locale) }} :
          </p>
          <p class="gestionASTTTextBold">{{ preinscription.data.nom }}</p>
        </div>
        <div class="row">
          <p class="gestionASTTText">
            {{ "preinscription_date_naissance" | translate(locale) }} :
          </p>
          <p class="gestionASTTTextBold">
            {{ this.formatDateFrancais(preinscription.data.dateNaissance) }}
          </p>
        </div>
        <div class="row">
          <p class="gestionASTTText">
            {{ "preinscription_numero_licence" | translate(locale) }} :
          </p>
          <p class="gestionASTTTextBold">
            {{ preinscription.data.licence.numeroLicence }}
          </p>
        </div>
        <div class="row">
          <p class="gestionASTTText">
            {{ "preinscription_categorie" | translate(locale) }} :
          </p>
          <p class="gestionASTTTextBold">
            {{ preinscription.data.licence.categorie }}
          </p>
        </div>
      </div>

      <div
        class="row mt-4 mb-3 w-100"
        style="border: 0.5px solid #d8d8d8; opacity: 0.24;"
      />

      <!-- Je souhaite -->
      <div class="jeSouhaitePart">
        <p class="gestionASTTTitle">JE SOUHAITE</p>
        <div class="row d-flex justify-content-left mb-4">
          <div class="title_line" style="width: 125px"></div>
        </div>

        <div class="row">
          <p class="gestionASTTText">
            {{
              "preinscription_pratique_sportive_club_principal"
                | translate(locale)
            }}
            :
          </p>
          <p class="gestionASTTTextBold">
            {{ pratiqueSportiveLibelle }}
          </p>
        </div>
        <div class="row">
          <p class="gestionASTTText">
            {{
              "preinscription_pratique_sportive_club_accueil"
                | translate(locale)
            }}
            :
          </p>
          <p class="gestionASTTTextBold">
            {{ preinscription.data.typeExtensionLibelle }} +
            {{ preinscription.data.typeCompetitionExtensionLibelle }}
          </p>
        </div>
      </div>

      <div
        class="row mt-4 mb-3 w-100"
        style="border: 0.5px solid #d8d8d8; opacity: 0.24;"
      />

      <!-- Clubs -->
      <div class="clubsPart">
        <p class="gestionASTTTitle">CLUBS</p>
        <div class="row d-flex justify-content-left mb-4">
          <div class="title_line" style="width: 70px"></div>
        </div>

        <div class="row">
          <p class="gestionASTTText">
            {{ "preinscription_club_principal" | translate(locale) }} :
          </p>
          <p class="gestionASTTTextBold">
            {{ preinscription.data.organisme.code }} -
            {{ preinscription.data.organisme.libelle }}
          </p>
        </div>
        <div class="row">
          <p class="gestionASTTText">
            {{ "preinscription_club_accueil" | translate(locale) }} :
          </p>
          <p class="gestionASTTTextBold">
            {{ preinscription.data.organismeExtension.code }} -
            {{ preinscription.data.organismeExtension.libelle }}
          </p>
        </div>
        <div
          v-if="preinscription.data.organismeCTCExtension.id != null"
          class="row"
        >
          <p class="gestionASTTText">
            {{ "preinscription_ctc" | translate(locale) }} :
          </p>
          <p class="gestionASTTTextBold">
            {{ preinscription.data.organismeCTCExtension.code }} -
            {{ preinscription.data.organismeCTCExtension.libelle }}
          </p>
        </div>
      </div>

      <div
        v-if="preinscription.data.typeExtension === 'T'"
        class="row mt-4 mb-3 w-100"
        style="border: 0.5px solid #d8d8d8; opacity: 0.24;"
      />

      <!-- Je m'engage -->
      <div
        v-if="preinscription.data.typeExtension === 'T'"
        class="jeMEngagePart"
      >
        <p class="gestionASTTTitle">JE M'ENGAGE</p>
        <div class="row d-flex justify-content-left mb-4">
          <div class="title_line" style="width: 130px"></div>
        </div>

        <div class="row">
          <p class="gestionASTTText">
            <span
              v-html="
                $options.filters.translate(
                  'preinscription_ast_je_mengage',
                  'fr'
                )
              "
            ></span>
          </p>
        </div>
      </div>
    </div>

    <div class="mt-5 pb-5">
      <b-button
        id="buttonValidation"
        variant="outline-primary"
        @click="validationGestionASTT(false /*isReconnected*/)"
        ><b-spinner
          v-if="isLoading === true"
          small
          label="Loading"
          class="mr-1"
        ></b-spinner>
        <span>JE SIGNE ET VALIDE</span></b-button
      >
    </div>
  </div>
</template>

<script>
import translations from "@/Translations.js";
import preinscriptionAppelsServeur from "@/preinscriptionUtils";
import _ from "lodash";

export default {
  components: {},
  props: {
    preinscription: null,
    token: null,
    locale: {
      type: String,
      default: "fr"
    }
  },
  data() {
    return {
      erreurGlobale: null, // valorisée dans traitementErreursServeur
      pratiqueSportiveLibelle: "",
      isLoading: false,
      token_out: undefined
    };
  },
  filters: {
    translate: function(value, locale) {
      return translations[locale][value];
    }
  },
  methods: {
    validationGestionASTT() {
      this.callServeur(false /*isReconnected*/);
    },
    callServeur(isReconnected) {
      var that = this;
      // quand l'utilisateur fait click sur le bouton "JE SIGNE ET JE VALIDE", le bouton devient grisé et un spinner apparait sur le bouton
      this.disableValidation(true);
      preinscriptionAppelsServeur
        .postEtape(this.token_out, "9", "", true, this.preinscription.data)
        .then(result => {
          that.preinscription.data = result;

          // le bouton "JE SIGNE ET JE VALIDE" devient actif si la validation côté serveur est bien passée
          that.disableValidation(false);
        })
        .catch(error => {
          // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
          var argsArray = [];
          preinscriptionAppelsServeur.traitementErreursServeur(
            error,
            isReconnected,
            that,
            that.callServeur,
            argsArray
          );

          if (that.erreurGlobale != null && that.erreurGlobale != "") {
            // le bouton "JE SIGNE ET JE VALIDE" devient actif si la validation côté serveur n'est pas bien passée
            that.disableValidation(false);
          }
        });
    },
    disableValidation(isDisabled) {
      var buttonValidation = document.getElementById("buttonValidation");
      buttonValidation.disabled = isDisabled;
      this.isLoading = isDisabled;
    },
    formatDateFrancais(date) {
      // format date au format français dd/MM/yyyy (la date d'entrée est au format yyyy-MM-dd)
      return preinscriptionAppelsServeur.formatDateFrancais(date);
    },
    getPratiqueSportiveLibelle(isReconnected) {
      var that = this;
      let code = this.preinscription.data.pratiqueSportive;
      if (code != null) {
        preinscriptionAppelsServeur
          .getByName(this.token_out, "TypePratiqueSportive")
          .then(result => {
            let pratiqueSportive = _.filter(result.data, ["code", code]);
            if (pratiqueSportive[0]) {
              that.pratiqueSportiveLibelle = pratiqueSportive[0].libelle;
            }
          })
          .catch(error => {
            // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
            var argsArray = [];
            preinscriptionAppelsServeur.traitementErreursServeur(
              error,
              isReconnected,
              that,
              that.getPratiqueSportiveLibelle,
              argsArray
            );
          });
      } else if (this.preinscription.data.typesPratique.includes("VS")) {
        that.pratiqueSportiveLibelle = "VxE - Basket Santé";
      } else if (this.preinscription.data.typesPratique.includes("VT")) {
        that.pratiqueSportiveLibelle = "VxE - BaskeTonik";
      } else if (this.preinscription.data.typesPratique.includes("VI")) {
        that.pratiqueSportiveLibelle = "VxE - Basket Inclusif";
      } else if (this.preinscription.data.typesPratique.includes("M")) {
        that.pratiqueSportiveLibelle = "Micro Basket";
      } else {
        that.pratiqueSportiveLibelle = "Pas de pratique sportive exercée";
      }
    }
  },
  watch: {
    token: function() {
      if (this.token) {
        this.token_out = JSON.parse(JSON.stringify(this.token));
      }
    }
  },
  created() {
    // la clone token_out est utilisée pour pouvoir mettre a jour le token si la session a expiré (on peut pas modifier directement un prop)
    if (this.token) {
      this.token_out = JSON.parse(JSON.stringify(this.token));
    }
  },
  mounted() {
    this.getPratiqueSportiveLibelle(false /*isReconnected*/);
  }
};
</script>

<style scoped>
.gestionASTT {
  background-color: #f0f0f1;
}

.jeSuisPart,
.jeSouhaitePart,
.clubsPart,
.jeMEngagePart {
  text-align: left;
  /* padding-left: 100px;
  position: relative;
  left: 50%; */
  padding-left: 20%;
  padding-right: 20%;
}

.gestionASTT .row {
  margin-left: 0;
  margin-right: 0;
  /* width: 50%; */
}

.gestionASTTTitle {
  margin-bottom: 10px;
  font-family: Lato;
  font-size: 18px;
  font-weight: bold;
  color: #000000;
}

p {
  margin-bottom: 5px;
}

.btn-outline-primary {
  background-color: #003690 !important;
  border-color: #003690 !important;
  width: 206px;
  height: 54px;
  border-radius: 27px !important;
}

.title_line {
  border-bottom: 8px solid #00abe7;
  margin-left: -5px;
  width: 100%;
  opacity: 0.5;
  bottom: 0px;
}

.gestionASTTText {
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  color: #000000;
}

.gestionASTTTextBold {
  font-family: Lato;
  font-size: 16px;
  font-weight: bold;
  color: #000000;
  margin-left: 10px;
}

@media (max-width: 768px) {
  .jeSuisPart,
  .jeSouhaitePart,
  .clubsPart,
  .jeMEngagePart {
    text-align: left;
    padding-left: 10%;
    padding-right: 10%;
  }
}

/* mobile phone */
@media (max-width: 480px) {
  .gestionASTT {
    margin: 10px 15px;
  }

  .gestionASTTTitle {
    font-size: 16px;
  }

  .gestionASTTText,
  .gestionASTTTextBold {
    font-size: 13px;
  }

  .gestionASTT-page-title {
    font-family: Lato;
    font-weight: bold;
    font-size: 16px;
    margin-top: 30px;
    margin-bottom: 30px;
  }
}

/* tablet */
@media (min-width: 481px) and (max-width: 1024px) {
  .gestionASTT {
    margin: 3rem 3rem;
  }

  .gestionASTT-page-title {
    font-family: Lato;
    font-weight: bold;
    font-size: 20px;
    margin-top: 30px;
    margin-bottom: 30px;
  }
}

/* laptops & desktops */
@media (min-width: 1025px) {
  .gestionASTT-container {
    margin: 3rem 8rem;
    min-height: 200px;
    width: auto;
  }

  .gestionASTT-page-title {
    font-family: Lato;
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 30px;
  }
}
</style>
